import { IValidPhone } from '../../types/offerData';

export enum EDynamicPhonesActionTypes {
  SET_PHONES = 'dynamicPhones/SET_PHONES',
}

export type TSetDynamicPhonesAction = {
  type: EDynamicPhonesActionTypes;
  phones: IValidPhone[];
};

export const setDynamicPhones = (phones: IValidPhone[]): TSetDynamicPhonesAction => ({
  type: EDynamicPhonesActionTypes.SET_PHONES,
  phones,
});

const initialState: IValidPhone[] | null = null;

/** Подменные номера динКТ (SEL-998); null — показываем статические номера оффера */
export function dynamicPhonesReducer(
  state: IValidPhone[] | null = initialState,
  action: TSetDynamicPhonesAction,
): IValidPhone[] | null {
  switch (action.type) {
    case EDynamicPhonesActionTypes.SET_PHONES:
      return action.phones;

    default:
      return state;
  }
}
